var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_149718",
    "data-name": "Group 149718",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.976,
    height: 23.976,
    viewBox: "0 0 23.976 23.976",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_102396",
    "data-name": "Path 102396",
    d: "M11.988,0A11.988,11.988,0,1,0,23.976,11.988,11.985,11.985,0,0,0,11.988,0Zm7.523,10.629-3.735,3.522,1.14,4.087c.229.826-.176,1.14-.916.7l-4.012-2.419L7.971,18.93c-.735.442-1.167.128-.959-.709l1.1-4.443L4.5,10.587c-.645-.57-.469-1.028.389-1.028h4.4L11.37,4.7c.341-.789.884-.789,1.215.005l2.041,4.854h4.454C19.942,9.564,20.134,10.043,19.511,10.629Z",
    fill: "#014cec"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.0109bb7670f89f453f3c6fb3afb8af0c.svg";
export { ForwardRef as ReactComponent };